import React, { useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import logo from "images/logo_varram_white.png";
import m_logo from "images/m/logo_varram_footer.png";
import { FaFacebookF } from "react-icons/fa";
import { AiFillYoutube } from "react-icons/ai";
import { AiFillInstagram } from "react-icons/ai";
import { useMediaQuery } from "react-responsive";
import $ from 'jquery';

const FooterWrapper = styled.footer`
  display: flex;
  flex-direction: column;
  background-color: #5f5f5f;
  color: #eee;
  width: 100%;
  margin-top: auto;

  @media only screen and (max-width: 960px) {
    min-width: 100%;
  }

  & .container {
    max-width: 1480px;
    width: 100%;
    margin: auto auto 0;

    @media only screen and (max-width: 960px) {
      padding: 0 15px;
    }
  }

  a {
    color: #eee;
    text-decoration: none;
  }

  & .border_line {
    border-bottom: 1px solid #8c8c8c;
    & .container {
      padding: 0;
    }
  }

  & .footer_up > ul {
    display: flex;
    align-items: center;
    margin: 0;
    height: 67px;

    @media only screen and (max-width: 960px) {
      text-align: center;
      justify-content: center;
      align-items: center;
      height: 50px;
    }

    & li {
      text-align: center;
      cursor: pointer;
      font-size: 0.938rem;
      &:not(:first-child) {
        margin-left: 27px;
      }
      @media only screen and (max-width: 960px) {
        flex: 1;
        font-size: 0.875rem;
        &:not(:first-child) {
          margin-left: 0;
        }
      }
    }
  }

  & .footer_down {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-bottom: 50px;

    @media only screen and (max-width: 960px) {
      flex-direction: column-reverse;
      padding-top: 25px;

      & div:nth-child(3) {
        order: 1;
      }
    }

    & div {
      & .underLine {
        position: relative;
        top: -7px;
        width: 16px;
        height: 1px;
        margin: 10px 0;
        background: #adadad;
        @media only screen and (max-width: 960px) {
          width: 12px;
          margin: 0;
        }
      }
    }

    p {
      font-size: 13px;
      line-height: 19px;
      color: #eee;
      @media only screen and (max-width: 960px) {
        margin-bottom: 5px;
        font-size: 0.875rem;
      }
      &.gray_title {
        margin-bottom: 6px;
        color: #ADADAD;
        font-size: 0.875rem;
        font-weight: 500;
        line-height: 21px;
        @media only screen and (max-width: 960px) {
          margin-bottom: 5px;
          font-size: 0.75rem;
          line-height: 17px;
        }
      }
      &.time {
        line-height: 19px;
        @media only screen and (max-width: 960px) {
          margin: 6px 0 25px;
          line-height: 18px;
        }
      }
    }

    & .bottom_info {
      & .company_info {
        & p {
          line-height: 19px;
          font-size: 0.813rem;
          &:last-child {
            margin-top: 25px;
          }
        }
        @media only screen and (max-width: 960px) {
          margin-top: 9px;
          & p {
            margin: 0;
            line-height: 17px;
            font-size: 0.75rem;
            &:last-child {
              margin-top: 20px;
            }
          }
        }
      }
    }
    

    & ul {
      position: absolute;
      top: -140px;
      right: 0px;
      float: right;
      display: flex;

      @media only screen and (max-width: 960px) {
        top: 25px;
        right: 0;
        flex-direction: column;
      }

      & li {
        border: 1px solid #8C8C8C;
        border-radius: 50px;
        width: 46px;
        height: 46px;
        display: flex;
        justify-content: center;
        margin: 0 10px 10px 10px;
        align-items: center;
        @media only screen and (max-width: 960px) {
          margin: 0 0 10px 0;
        }

        & a {
          margin: -3px 0 0 2px;
          font-size: 1.2rem;
          @media only screen and (max-width: 960px) {
            margin: -3px 0 0 1px;
          }
        }
      }
    }
  }
`;

const Footer = () => {
  const isPc = useMediaQuery({ query: "(min-width: 960px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 960px)" });

  useEffect(() => {
    var url =
        "http://www.ftc.go.kr/bizCommPop.do?wrkr_no=1308637082"
    $(document).ready(function(){
      $('.ftc_btn').click(function(){
        window.open(url, "bizCommPop", "width=750, height=700;");
        return false;
      });
    });
  })

  return (
    <>
      <FooterWrapper id="footer">
        <div className="border_line">
          <div className="container">
            <div className="footer_up">
              <ul>
                <li>
                  <Link to="/brand">
                    <span>회사소개</span>
                  </Link>
                </li>
                <li>
                  <Link to="/privacy">개인정보처리방침</Link>
                </li>
                <li>
                  <Link to="/terms">이용약관</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="container">
          {isPc && (
            <div style={{ margin: "30px 0 20px" }}>
              <img src={logo} alt="로고이미지" />
            </div>
          )}
          <div className="footer_down">
            <ul>
              <li>
                <a href="https://www.facebook.com/varramkorea/" target="_blank"  rel="noopener noreferrer">
                  <FaFacebookF />
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/c/바램펫/featured"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <AiFillYoutube />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/varram_korea/"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
            <div className="bottom_info">
              {isMobile && (
                <div style={{ margin: "45px 0 10px" }}>
                  <img src={m_logo} alt="로고이미지" style={{height: "22px"}} />
                </div>
              )}
              <p className="gray_title">바램펫 (VARRAM)</p>
              <div className="company_info">
                <p>(주)바램시스템｜대표자 : 서병조 | 브랜드 : 바램펫{" "}
                  {isPc ? "|" : <br />} 사업자 등록번호: <span className="ftc_btn" style={{cursor:"pointer"}}>130-86-37082  [사업자
                  등록 조회]</span>
                </p>
                <p>통신판매업신고: 제 2016-대전유성-0495호</p>
                <p>[본사] 대전광역시 유성구 국제과학 22로 44 (구룡동)</p>
                <p>[서울] 경기도 광명시 새빛공원로67 자이타워 B 1508</p>
                <p>Copyright (c) VARRAM. All rights reserved.</p>
              </div>
            </div>
            <div>
              <p className="gray_title">고객만족센터</p>
              {/*<p>support@varram.com</p>*/}
              <p>1670.8921</p>
              <br />
              <p className="underLine"></p>
              <p className="time">Mon - Fri 09:30 ~ 17:00<br />Lunch {isPc ? "Break" : "Time"} 12:00 ~ 13:00</p>
            </div>
            <div>
              <p className="gray_title">
                Contact Email(제휴 &amp; 마케팅)
              </p>
              <p>mkt@varram.com</p>
            </div>
          </div>
        </div>
      </FooterWrapper>
    </>
  );
};

export default Footer;
